<!-- 上传视频 -->
<template>
    <div v-if="componentsData.type == 17">
        <div class="bg-div" :style="bgStyle">
            <div
                v-if="componentsData.content.title"
                :style="titleStyle"
                class="title-box"
            >
                {{ componentsData.content.title }}
            </div>
            <div :style="txtStyle" class="upload-boxs">
                <div class="upload-box">
                    <Icon
                        type="md-videocam"
                        size="30"
                        :color="componentsData.content.icon_background_color"
                    />
                </div>
                <div :style="textStyle">
                    最多上传{{ componentsData.content.maximum_upload }}张
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        textStyle() {
            const content = this.componentsData.content;
            return {
                color: content.prompt_text_color,
            };
        },
        txtStyle() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
                border: `1px solid ${content.border_color}`,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.upload-boxs {
    padding: 6px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.upload-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    background: #fff;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
</style>
